import { CHAT_TYPES } from 'helper/const';

export const adminPermission = {
  isAdmin: true,
  tabLabels: ['Internal', 'Client'],
  internalType: CHAT_TYPES.INTERNAL_DEPARTMENT,
  showDepartmentAtIndividual: false,
};
